import type { BaseDecoration, Decoration } from './types/decoration';

/**
 * Builds a `Decoration` that visually highlights a matched search term
 * range within a line of code, using `<mark>` markup emphasised in bold.
 *
 * Bold rather than a colour of its own, so the match keeps whatever the
 * syntax theme coloured it. `CodeLine` resets the UA `<mark>` styling.
 *
 * Consumers reach for this helper when they want to visually highlight
 * search term matches without diverging from the look adopted by other
 * consumers of this package — for example, to highlight matches
 * produced by their own client-side matcher, or to compose highlights
 * alongside other decoration kinds.
 */
export const searchHighlightDecoration = ({
	lineNumber,
	startChar,
	endChar,
}: BaseDecoration): Decoration => ({
	lineNumber,
	startChar,
	endChar,
	tagName: 'mark',
	style: {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- `font.weight.bold` is 653, too close to the inherited 400 to read as a match; `bolder` gives 700, as `@atlaskit/code` does for code tokens
		fontWeight: 'bolder',
	},
});
